<template>
  <div>
    <div class="page-header">
      <div class="page-header-left">
        <ol class="breadcrumb ml-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'welcome' }">
              <feather type="home" />
            </router-link>
          </li>
          <li class="breadcrumb-item active">
            {{ $t('companyFormAdminView.vendorManagement') }}
          </li>
        </ol>
      </div>
      <h4 class="my-3">
        {{ $t('companyFormAdminView.vendorManagement') }}
      </h4>
    </div>
    <div class="row">
      <div class="col-md-4 col-12 mb-3">
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({name: 'vendorManagementFormList'})"
        >
          <div class="card-body">
            <div class="media ">
              <feather
                type="layers"
                class="m-r-30 "
              />
              <div class="media-body align-self-center">
                <h6 class="f-w-600">
                  {{ $t('companyFormAdminView.tdarkDyrlndirmFormalar') }}
                </h6>
                <p>{{ $t('vendorManagementDashboard.tdarklrinDyrlndirimsiNFormalar') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 mb-3">
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({name: 'vendorManagementVendorList'})"
        >
          <div class="card-body">
            <div class="media ">
              <feather
                type="user-check"
                class="m-r-30 "
              />
              <div class="media-body align-self-center">
                <h6 class="f-w-600">
                  {{ $t('companyVendors.tsdiqlnmiTdarklr') }}
                </h6>
                <p>{{ $t('vendorManagementDashboard.irktinizTrfindnTsdiqlnmiTdarklr') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 mb-3">
        <div
          class="card h-100 mb-0 pointer"
          @click.prevent="$router.push({name: 'vendorManagementBlackList'})"
        >
          <div class="card-body">
            <div class="media ">
              <feather
                type="x-octagon"
                class="m-r-30 "
              />
              <div class="media-body align-self-center">
                <h6 class="f-w-600">
                  {{ $t('vendorManagementBlacklist.qaraSiyah') }}
                </h6>
                <p>{{ $t('vendorManagementDashboard.irktinizinTklifAlmaqIstmdiyiIrktlr') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <div class="lead">
                {{ $t('vendorManagementRequestChart.tdarkMracitlri') }}
              </div>
              <div>
                <router-link
                  class="btn btn-outline-dark"
                  :to="{name: 'vendorManagementRequestList'}"
                >
                  {{ $t('vendorManagementVendorRequestReport.btnMracitlr') }}
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body p-0">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>{{ $t('vendorManagementPurchasesReports.faliyytSahsi') }}</th>
                  <th>{{ $t('vendorManagementVendorRequestReport.tsdiqlnmiTdark') }}</th>
                  <th>{{ $t('vendorManagementVendorRequestReport.tsdiqlnmiMracit') }}</th>
                  <th>{{ $t('vendorManagementVendorRequestReport.gzlynMracit') }}</th>
                  <th>{{ $t('vendorManagementVendorRequestReport.geriQaytarlmMracit') }}</th>
                  <th>{{ $t('vendorManagementVendorRequestReport.yenidnDoldurulacaqMracit') }}</th>
                  <th>{{ $t('vendorManagementVendorRequestReport.lvEdilmiMracit') }}</th>
                </tr>
              </thead>
              <tbody class="text-center">
                <tr v-if="sectorVendorStatistics.length<1">
                  <td colspan="7">
                    <div class="alert-danger py-4">
                      {{ $t('vendorManagementDashboard.tdarkMracitiYoxdur') }}
                    </div>
                  </td>
                </tr>

                <template v-for="s in sectorVendorStatistics">
                  <tr>
                    <td class="text-left">
                      <span v-if="s.profileType==='LOGISTIC'">{{ $t('vendorManagementVendorRequestReport.logistikMracitlri') }}</span>
                      <span v-else-if="s.profileType==='TRUCK'">{{ $t('vendorManagementVendorRequestReport.trSahibiMracitlri') }}</span>
                      <span v-else>{{ s.sectorName }}</span>
                    </td>

                    <td>
                      <router-link
                        v-if="s.vendorCount>0"
                        class="badge bg-success"
                        :to="{name: 'vendorManagementVendorList', query:{sectorId: s.sectorId, profile: s.profileType}}"
                      >
                        {{ s.vendorCount }}
                      </router-link>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <router-link
                        v-if="s.approvedFormCount>0"
                        class="badge bg-success"
                        :to="{name: 'vendorManagementRequestList', query:{ status: 'APPROVED', sector: s.sectorId, profile: s.profileType}}"
                      >
                        {{ s.approvedFormCount || '-' }}
                      </router-link>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <router-link
                        v-if="s.waitingFormCount>0"
                        class="badge bg-danger"
                        :to="{name: 'vendorManagementRequestList', query:{ status: 'WAITING', sector: s.sectorId, profile: s.profileType}}"
                      >
                        {{ s.waitingFormCount || '-' }}
                      </router-link>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <router-link
                        v-if="s.returnedFormCount>0"
                        class="badge bg-warning"
                        :to="{name: 'vendorManagementRequestList', query:{ status: 'RETURNED', sector: s.sectorId, profile: s.profileType}}"
                      >
                        {{ s.returnedFormCount || '-' }}
                      </router-link>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <router-link
                        v-if="s.expiredFormCount>0"
                        class="badge bg-primary"
                        :to="{name: 'vendorManagementRequestList', query:{ status: 'EXPIRED', sector: s.sectorId, profile: s.profileType}}"
                      >
                        {{ s.expiredFormCount || '-' }}
                      </router-link>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <router-link
                        v-if="s.rejectedFormCount>0"
                        class="badge bg-dark"
                        :to="{name: 'vendorManagementRequestList', query:{ status: 'REJECTED', sector: s.sectorId, profile: s.profileType}}"
                      >
                        {{ s.rejectedFormCount || '-' }}
                      </router-link>
                      <span v-else>-</span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {
  getFormSectorStatistics,
} from "@/repositories/VendorManagementRepository";
import CompanyFormStatus from "@/pages/scc/vendorManagement/utils/CompanyFormStatus.vue";

import Multiselect from 'vue-multiselect'
import CompanyFormRequestStatus from "@/pages/scc/vendorManagement/utils/CompanyFormRequestStatus.vue";

export default {
  components: {
    CompanyFormRequestStatus, Multiselect, CompanyFormStatus,
  },
  data() {
    return {
      mediaBase: mediaBase,
      sectorVendorStatistics: [],

    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),


  },
  mounted() {
    this.getFormFormSectorStatistics();
  },
  methods: {


    getFormFormSectorStatistics() {

      getFormSectorStatistics(this.token).then(({code, statistics, requests30Days}) => {
        if (code === 200) {
          this.sectorVendorStatistics = statistics;
        }
      })

    },

  }

}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
